import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "@/store/store";
import _ from "lodash";
import Icon from "@/components/global/icon";
import Vuebar from "vuebar";
import api from "@/libs/api";
import Helper from "@/libs/helper";
import "./quasar";

api.init(store);

Vue.use(Vuebar);
Vue.component("icon", Icon);

Vue.config.productionTip = false;

Object.defineProperty(Vue.prototype, "_", { value: _ });
Object.defineProperty(Vue.prototype, "Helper", { value: Helper });


new Vue({
	router,
	store,
	render: h => h(App)
}).$mount("#app");
